<app-add-poi [viewTitle]="title" *ngIf="showForm" [parentIdValue]="parentIdValue"></app-add-poi>